import { Spinner } from 'react-bootstrap';

const Loading = () => {
  return (<>
  <div style={{textAlign:'center', alignContent:'center'}}>
      <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
      </Spinner>
  </div>
  {/* <div><a href='/'><button type="button" class="btn btn-primary" id="button">Close</button></a></div> */}
  </>)
};

export default Loading;